import { call, put, takeLatest } from 'redux-saga/effects';
import dashboardService from '../../services/dashboardService';
import {
  fetchStatistics,
  fetchStatisticsSuccess,
  fetchStatisticsFailure,
} from './slice';

function* handleFetchStatistics() {
  try {
    const response = yield call(dashboardService.getStatistics);
    yield put(fetchStatisticsSuccess(response));
  } catch (error) {
    yield put(fetchStatisticsFailure(error.message));
  }
}

export function* watchDashboardActions() {
  yield takeLatest(fetchStatistics.type, handleFetchStatistics);
}
